import { gql, TypedDocumentNode } from "@apollo/client";

import { Repo, MutationRepoUpdateArgs } from "types/generated";

import { SPACELIFT_VCS_REPO_BASIC_FRAGMENT } from "../gql";

export const UPDATE_SPACELIFT_VCS_REPO: TypedDocumentNode<
  { repoUpdate: Repo },
  MutationRepoUpdateArgs
> = gql`
  mutation UpdateSpaceliftVcsRepo($id: ID!, $input: RepoUpdateInput!) {
    repoUpdate(id: $id, input: $input) {
      ...SpaceliftVcsRepoBasic
    }
  }
  ${SPACELIFT_VCS_REPO_BASIC_FRAGMENT}
`;
